export const buttonBorderRadiusStyle = `
  border-radius: 4px;
`;